// 인쇄소·카톡에 보낼 PNG 한 변 크기(px).
export const QR_PNG_SIZE = 1024;

// 크기 없는 SVG 는 Firefox 가 canvas 에 못 그린다 — 여는 태그의 width·height 를 지정한 크기로 갈아 끼운다.
export const sizedSvg = (svg: string, size: number): string =>
  svg.replace(/<svg\b([^>]*)>/, (_, attrs: string) => {
    const rest = attrs.replace(/\s(?:width|height)="[^"]*"/g, "");
    return `<svg width="${size}" height="${size}"${rest}>`;
  });

// 브라우저에서 QR SVG 를 흰 배경 PNG 로 래스터화한다.
export const qrPngBlob = (svg: string, size: number = QR_PNG_SIZE): Promise<Blob> =>
  new Promise((resolve, reject) => {
    const image = new Image();
    // 동기 예외(drawImage 보안 오류 등)도 reject 로 넘겨야 호출자가 영원히 기다리지 않는다.
    image.onload = () => {
      try {
        const canvas = document.createElement("canvas");
        canvas.width = size;
        canvas.height = size;
        const context = canvas.getContext("2d");
        if (!context) return reject(new Error("canvas 를 쓸 수 없습니다"));
        context.imageSmoothingEnabled = false;
        context.fillStyle = "white";
        context.fillRect(0, 0, size, size);
        context.drawImage(image, 0, 0, size, size);
        canvas.toBlob((blob) => (blob ? resolve(blob) : reject(new Error("PNG 를 만들지 못했습니다"))), "image/png");
      } catch (error) {
        reject(error instanceof Error ? error : new Error("PNG 를 만들지 못했습니다"));
      }
    };
    image.onerror = () => reject(new Error("QR 그림을 읽지 못했습니다"));
    image.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(sizedSvg(svg, size))}`;
  });
